import { useQuery, useMutation, useInfiniteQuery } from 'react-query';

function useVahakQuery(queryKey, queryFn, options) {
    return useQuery(queryKey, queryFn, options);
}
function useVahakMutationQuery(mutationKey, mutationFn, options) {
    return useMutation(mutationKey, mutationFn, options);
}
function useVahakInfiniteQuery(queryKey, queryFn, options) {
    return useInfiniteQuery(queryKey, queryFn, options);
}

export { useVahakInfiniteQuery, useVahakMutationQuery, useVahakQuery };
//# sourceMappingURL=useVahakQueryClient.js.map
